module.exports = __webpack_public_path__ + "img/星链数据横版定稿白色logo.69d7ba50.png";